import axios from 'axios';

export interface ViaCepResponse {
    cep: string;
    logradouro: string;
    complemento: string;
    bairro: string;
    localidade: string;
    uf: string;
    erro?: boolean;
}

/// Consulta de CEP no ViaCEP, com axios puro: a instância da API mandaria token e chave a terceiros.
export class SearchCepService {
    private url = 'https://viacep.com.br/ws';

    public async search(cep: string) {
        return axios.get<ViaCepResponse>(`${this.url}/${cep}/json`);
    }
}
